export default {
    Carousel: {
        BEFORE_SLIDE: 'carousel:before_slide',
        PAGE_CHANGED: 'carousel:page_changed'
    },
    Template: {
        AgentPortal: {
            Signin: {
                SIGNIN_SUCCESS: 'HSN.Template.AgentPortal.'
            }
        }
    },
    Widget: {
        Signin: {
            COMPLETE: 'HSN.Widget.Signin:COMPLETE',
            FAILED: 'HSN.Widget.Signin:FAILED',
            FORGOT_PASSWORD_INITIATED: 'HSN.Widget.Signin.FORGOT_PASSWORD_INITIATED',
            NEW_CUSTOMER_INITIATED: 'HSN.Widget.Signin.NEW_CUSTOMER_INITIATED'
        },
        Tabs: {
            SHOW: 'HSN.Widget.Tabs:SHOW'
        },
        Video: {
            TOGGLE_INLINE_PLAYER: 'videoplayer:toggle_inline_player'
        }
    },
    AdobeTarget: {
        LOADED: 'HSN.AdobeTarget:LOADED'
    },
    Bazaarvoice: {
        LOADED: 'HSN.Bazaarvoice:LOADED',
        REVIEWS_LOADED: 'HSN.Bazaarvoice:REVIEWS_LOADED'
    },
    Config: {
        LOADED: 'HSN.Config:LOADED',
    }
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Events.js